document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".product-detail-collapsible-btn");

  // Open the first one by default
  if (buttons.length > 0) {
    const firstBtn = buttons[0];
    const firstContent = firstBtn.nextElementSibling;
    firstBtn.classList.add("active");
    firstContent.classList.add("active");
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const thisContent = this.nextElementSibling;
      const isOpen = this.classList.contains("active");

      // Close all others
      buttons.forEach(btn => {
        const content = btn.nextElementSibling;
        btn.classList.remove("active");
        content.classList.remove("active");
        content.style.maxHeight = null;
      });

      // Toggle current
      if (!isOpen) {
        this.classList.add("active");
        thisContent.classList.add("active");
        thisContent.style.maxHeight = thisContent.scrollHeight + "px";
      }
    });
  });
});